/*
<summary>
   This file is used to provide initial values or state to the AddProcessForm.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IAddProcess } from '../../models/forms/IAddUpdateProcess';
const initialProcessState: IAddProcess = {
  ProcessName: '',
  Type: '-1',
  Comment: '',
  ShortName: '',
};

export default initialProcessState;
